// Image Block View Component (Read-only)
import React from 'react';

const ImageBlockView = ({ content }) => {
  const { url, alt, caption } = content || {};

  if (!url) return null;

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1">
        <img
          src={url}
          alt={alt || ''}
          className="w-full h-full object-cover rounded-lg"
        />
      </div>
      {caption && (
        <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2 italic">
          {caption}
        </p>
      )}
    </div>
  );
};

export default ImageBlockView;
